// extracted by mini-css-extract-plugin
module.exports = {"new":"new-module__new___VN0PZ","new__icon":"new-module__new__icon___LGebD","side_right":"new-module__side_right___-kkhB","side_left":"new-module__side_left___ypB0X"};